import { declareTheme } from "./themes";

export default declareTheme({
  VTab: {
    normal: {
      wrapper: 'px-1.5',
      content: 'py-1 text-sm leading-5'
    },
    small: {
      wrapper: 'px-1.5',
      content: 'py-1 text-sm leading-5'
    },
    tiny: {
      wrapper: 'px-1.5',
      content: 'py-1 text-xs leading-4'
    },
    active: 'text-primary-500 bg-primary-200 font-semibold',
    underline: false
  },
  VTabPanel: {
    normal: {
      iconSize: 'sm'
    },
    small: {
      iconSize: 'sm'
    },
    tiny: {
      iconSize: 'xs'
    },
    wrapper: '',
    buttonWrapper: 'gap-3'
  },
  VAvatar: {
    container: 'text-neutral-950 bg-primary-150 border-neutral-500 border'
  },
  VTextArea: {
    content: {
      disabled: 'text-neutral-400 bg-neutral-150 ring-neutral-200',
      readonly: 'text-neutral-950 bg-neutral-150 ring-0',
      enabled: 'text-neutral-950 bg-neutral-100 ring-neutral-300'
    }
  },
  VInput: {
    content: {
      disabled: 'text-neutral-400',
      readonly: 'text-neutral-950',
      enabled: 'text-neutral-950',
    },
    wrapper: {
      default: {
        disabled: 'text-neutral-400 bg-neutral-150 shadow-neutral-200',
        readonly: 'text-neutral-950 bg-neutral-150 shadow-none',
        enabled: 'text-neutral-950 bg-neutral-100 shadow-neutral-300',
      },
      underlined: {
        disabled: 'text-neutral-400 shadow-neutral-200',
        readonly: 'text-neutral-950 shadow-neutral-200',
        enabled: 'text-neutral-950 shadow-neutral-300',
      }
    }
  },
  VNumber: {
    container: 'gap-1.5',
    content: {
      base: 'rounded',
      enabled: 'text-neutral-950 bg-white',
      disabled: 'text-neutral-400 bg-neutral-150',
      readonly: 'text-neutral-950 bg-neutral-150',
    },
    wrapper: {
      enabled: 'ring-neutral-200',
      disabled: 'ring-neutral-200',
      readonly: 'ring-0'
    },
    focus: false
  },
  VSLabel: {
    text: 'text-xs text-neutral-500 font-normal'
  },
  VSDescription: {
    text: 'text-xs leading-4 text-neutral-500'
  },
  VContextMenu: {
    container: 'rounded shadow-lg'
  },
  VSSelectBase: {
    outline: false,
    focus: false,
    button: {
      base: 'px-3 py-1 text-xs leading-5 font-medium hover:bg-primary-250',
      text: 'text-neutral-500'
    },
    icon: {
      size: 'xs',
      up: 'Editor/DropDown',
      down: 'Editor/DropDown',
      color: 'neutral/500'
    },
    option: {
      text: 'text-neutral-500'
    }
  },
  VSContextMenuItem: {
    container: 'min-h-6 h-6 text-xs font-medium gap-1.5',
    label: 'px-1',
    menu: '',
    icon: 'xs',
    button: {
      base: 'px-1',
      colors: {
        default: {
          enabled: 'hover:bg-primary-150 hover:text-primary-500 text-neutral-500',
          disabled: 'text-neutral-400'
        },
        red: {
          enabled: 'hover:bg-red-100 text-red-500',
          disabled: 'text-red-400'
        }
      }
    }
  },
  VSwitch: {
    xs: {
      container: 'min-h-4',
      button: {
        base: 'h-4 w-7 p-0.5 before:w-3 before:h-3 before:left-0.5 before:top-0.5 bg-neutral-250 hover:bg-neutral-200 active:bg-neutral-300',
        active: 'before:translate-x-3 bg-primary-500 hover:!bg-primary-450 active:!bg-primary-550'
      }
    },
    sm: {
      container: 'min-h-4',
      button: {
        base: 'h-4 w-7 p-0.5 before:w-3 before:h-3 before:left-0.5 before:top-0.5 bg-neutral-250 hover:bg-neutral-200 active:bg-neutral-300',
        active: 'before:translate-x-3 bg-primary-500 hover:!bg-primary-450 active:!bg-primary-550'
      }
    },
    lg: {
      container: 'min-h-4',
      button: {
        base: 'h-4 w-7 p-0.5 before:w-3 before:h-3 before:left-0.5 before:top-0.5 bg-neutral-250 hover:bg-neutral-200 active:bg-neutral-300',
        active: 'before:translate-x-3 bg-primary-500 hover:!bg-primary-450 active:!bg-primary-550'
      }
    },
    xl: {
      container: 'min-h-4',
      button: {
        base: 'h-4 w-7 p-0.5 before:w-3 before:h-3 before:left-0.5 before:top-0.5 bg-neutral-250 hover:bg-neutral-200 active:bg-neutral-300',
        active: 'before:translate-x-3 bg-primary-500 hover:!bg-primary-450 active:!bg-primary-550'
      }
    },
    base: {
      container: 'min-h-4',
      button: {
        base: 'h-4 w-7 p-0.5 before:w-3 before:h-3 before:left-0.5 before:top-0.5 bg-neutral-250 hover:bg-neutral-200 active:bg-neutral-300',
        active: 'before:translate-x-3 bg-primary-500 hover:!bg-primary-450 active:!bg-primary-550'
      }
    }
  },
  VButton: {
    button: 'rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500',
    colors: {
      'contained/primary': 'border-primary-500 bg-primary-500 text-neutral-100 hover:bg-primary-450 hover:border-primary-450 active:bg-primary-550 active:border-primary-550',
      'outlined/primary': 'border-primary-500 bg-primary-100 text-primary-500 hover:text-primary-450 hover:border-primary-450 active:bg-primary-150 active:text-primary-550 active:border-primary-550',
      'text/primary': 'text-primary-500 hover:text-primary-450 active:text-primary-550',
      'contained/secondary': '',
      'outlined/secondary': 'border-neutral-300 hover:border-neutral-250 active:border-neutral-350 bg-neutral-100 active:bg-neutral-150 text-neutral-900 hover:text-neutral-850 active:text-neutral-950',
      'text/secondary': 'text-neutral-900 hover:text-neutral-850 active:text-neutral-950',
      'contained/tertiary': 'bg-neutral-50 border-neutral-500 text-neutral-950 hover:text-neutral-750 active:text-neutral-600',
      'outlined/tertiary': '',
      'text/tertiary': 'text-neutral-500 hover:text-neutral-450 active:text-neutral-600',
      'contained/red': 'border-red-500 bg-red-500 text-neutral-100 hover:bg-red-450 hover:border-red-450',
      'outlined/red': 'border-red-500 hover:border-red-450 active:border-red-550 bg-neutral-100 hover:bg-red-100 active:bg-red-150 text-red-500 hover:text-red-450 active:text-red-550 focus-visible:outline-red-500',
      'text/red': ''
    },
    sizes: {
      'xl': 'py-2.5 px-3.5 text-base leading-6 font-semibold',
      'lg': 'py-2 px-3 text-sm leading-5 font-semibold',
      'base': 'py-1.5 px-2.5 text-sm leading-5 font-semibold',
      'sm': 'py-1 px-2 text-sm leading-5 font-semibold',
      'xs': 'py-1 px-2 text-xs leading-4 font-semibold',
      'text_xl': 'text-base leading-6 font-semibold',
      'text_lg': 'text-sm leading-5 font-semibold',
      'text_base': 'text-sm leading-5 font-semibold',
      'text_sm': 'text-sm leading-5 font-semibold',
      'text_xs': 'text-xs leading-4 font-semibold',
      'icon_xl': 'p-2.5',
      'icon_lg': 'p-2',
      'icon_base': 'p-1.5',
      'icon_sm': 'p-1',
      'icon_xs': 'p-1'
    }
  }
})
